/**
 * Public client configuration.
 *
 * No build-time secrets live here — the Cognito app client is public (PKCE,
 * no secret). The fallback values below are the production defaults; CI
 * (`.github/workflows/deploy-web.yml`) always injects per-environment
 * `VITE_*` values read from the CloudFormation stack outputs at build time,
 * so these literals only matter for local development without overrides (see
 * `.env.example`).
 */

function fromEnv(value: string | undefined, fallback: string): string {
  const resolved = (value ?? '').trim() || fallback;
  return resolved.endsWith('/') ? resolved.slice(0, -1) : resolved;
}

/** Backend origin (no trailing slash, no `/api` prefix). */
export const API_BASE_URL = fromEnv(import.meta.env.VITE_API_BASE_URL, 'https://api.screenatlas.app');

/** Cognito Hosted UI origin for the OAuth code + PKCE flow. */
export const AUTH_DOMAIN = fromEnv(import.meta.env.VITE_AUTH_DOMAIN, 'https://auth.screenatlas.app');

/** Public Cognito app client id — the same client the mobile app uses. */
export const COGNITO_CLIENT_ID = fromEnv(
  import.meta.env.VITE_COGNITO_CLIENT_ID,
  '53khdfoe6t95373lv6eg60bbjl',
);

/** Image CDN that serves the mirrored TMDB artwork (`*_key` fields). */
export const IMAGES_BASE_URL = fromEnv(
  import.meta.env.VITE_IMAGES_BASE_URL,
  'https://dazlx7yiuf9js.cloudfront.net',
);
